import React from "react";
import { BehaviorSubject } from "rxjs";
import PropTypes from "prop-types";
import TagEl from "./TagEl";
import DomTree from "../../models/DomTree";
import { DISPLAY_CLASS_DICT } from "../../constants/domElConstants";

function FormattedText({ domTree, highlighted$, selected$, isAutoScroll }) {
  const { els, HtmlTag, attr, data } = domTree;

  if (data) {
    return (
      <TagEl
        tag={data}
        selected$={selected$}
        highlighted$={highlighted$}
        isAutoScroll={isAutoScroll}
      >
        {els.map((x) => (
          <FormattedText
            highlighted$={highlighted$}
            selected$={selected$}
            key={x.id}
            domTree={x}
            isAutoScroll={isAutoScroll}
          />
        ))}
        {domTree.innerText}
      </TagEl>
    );
  }

  if (els && els.length > 0) {
    return (
      <HtmlTag className={DISPLAY_CLASS_DICT[attr]}>
        {domTree.label ? (
          <div className="pub-text-label">{domTree.label}</div>
        ) : null}
        {els.map((x) => (
          <FormattedText
            highlighted$={highlighted$}
            selected$={selected$}
            key={x.id}
            domTree={x}
            isAutoScroll={isAutoScroll}
          />
        ))}
      </HtmlTag>
    );
  }

  return (
    <HtmlTag className={DISPLAY_CLASS_DICT[attr]}>{domTree.innerText}</HtmlTag>
  );
}

FormattedText.propTypes = {
  domTree: PropTypes.instanceOf(DomTree),
  highlighted$: PropTypes.instanceOf(BehaviorSubject).isRequired,
  selected$: PropTypes.instanceOf(BehaviorSubject).isRequired,
  isAutoScroll: PropTypes.bool,
};

FormattedText.defaultProps = {
  domTree: {},
  isAutoScroll: false,
};

export default FormattedText;
